/** Cross-tab sync for notification read/dismissed state via BroadcastChannel. */

const BROADCAST_CHANNEL_NAME = 'scalar:notificationCenter:v1';

export type NotificationBroadcastEvent =
  | { type: 'read'; userId: number; id: string }
  | { type: 'dismissed'; userId: number; id: string; acknowledgedAt: number }
  | { type: 'dismissedMany'; userId: number; ids: string[]; acknowledgedAt: number };

export function openNotificationBroadcastChannel(): BroadcastChannel | null {
  if (typeof BroadcastChannel === 'undefined') return null;
  try {
    return new BroadcastChannel(BROADCAST_CHANNEL_NAME);
  } catch {
    return null;
  }
}

export function broadcastNotificationEvent(
  channel: BroadcastChannel | null,
  event: NotificationBroadcastEvent
): void {
  try {
    channel?.postMessage(event);
  } catch {
    // ignore — private mode or channel closed
  }
}
